import API_URL from '../config';
import axios from 'axios';

import { getCookie } from './../utils/cookies';

export const addNewStockEntryEssayApi = async (objectData) => {
    try {
        const token = getCookie("T6hVzR7c0g3maM3F")
        const iv = getCookie("02hfCmUqpk66w4uG")
        const id = getCookie("3F2Mb2pJ1YRro5Z4")

        const option = {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }

        const ObjectData = objectData

        const res = await axios.post(`${API_URL}/api/V2/stockEnterEssay/addStockEnter/${id}/${iv}`, ObjectData, option);
        return res.data
    }
    catch (err) {
        throw err
    }
}

export const updateStockEssayApi = async (objectData, saveData, validationRequired = "false") => {
    try {
        const token = getCookie("T6hVzR7c0g3maM3F")
        const iv = getCookie("02hfCmUqpk66w4uG")
        const id = getCookie("3F2Mb2pJ1YRro5Z4")

        const option = {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }

        const ObjectData = {
            Products: objectData
        }

        const res = await axios.post(`${API_URL}/api/V2/stockEnterEssay/updateStock/${id}/${iv}?saveData=${saveData}&validationRequired=${validationRequired}`, ObjectData, option);
        return res.data
    }
    catch (err) {
        throw err
    }
}

export const getAllStockEntryEssayApi = async (Produit, LotNumber, selectedFromDate, selectedToDate) => {
    try {
        const token = getCookie("T6hVzR7c0g3maM3F")
        const iv = getCookie("02hfCmUqpk66w4uG")
        const id = getCookie("3F2Mb2pJ1YRro5Z4")

        const option = {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }

        const res = await axios.get(`${API_URL}/api/V2/stockEnterEssay/getAllEnters/${id}/${iv}?Produit=${Produit}&LotNumber=${LotNumber}&selectedFromDate=${selectedFromDate}&selectedToDate=${selectedToDate}`, option);
        return res.data
    }
    catch (err) {
        throw err
    }
}

export const deleteOneStockEnterEssayApi = async (StockEnterID) => {
    try {
        const token = getCookie("T6hVzR7c0g3maM3F")
        const iv = getCookie("02hfCmUqpk66w4uG")
        const id = getCookie("3F2Mb2pJ1YRro5Z4")

        const option = {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }

        const res = await axios.delete(`${API_URL}/api/V2/stockEnterEssay/deleteOneStockEnter/${id}/${iv}/${StockEnterID}`, option);
        return res.data
    }
    catch (err) {
        throw err
    }
}

export const deleteOneStockEnterEssayHistoryApi = async (StockEnterID, historyID) => {
    try {
        const token = getCookie("T6hVzR7c0g3maM3F")
        const iv = getCookie("02hfCmUqpk66w4uG")
        const id = getCookie("3F2Mb2pJ1YRro5Z4")

        const option = {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }

        const res = await axios.delete(`${API_URL}/api/V2/stockEnterEssay/deleteOneStockEnterHistory/${id}/${iv}/${StockEnterID}/${historyID}`, option);
        return res.data
    }
    catch (err) {
        throw err
    }
}

export const exportStockEnterEssayExcelApi = async (Produit, LotNumber, selectedFromDate, selectedToDate) => {
    try {
        const token = getCookie("T6hVzR7c0g3maM3F")
        const iv = getCookie("02hfCmUqpk66w4uG")
        const id = getCookie("3F2Mb2pJ1YRro5Z4")

        const option = {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }

        const res = await axios.get(`${API_URL}/api/V2/stockEnterEssay/exportExcel/${id}/${iv}?Produit=${Produit}&LotNumber=${LotNumber}&selectedFromDate=${selectedFromDate}&selectedToDate=${selectedToDate}`, option);
        return res.data
    }
    catch (err) {
        throw err
    }
}

export const getAllStockEntryByLotNumberEssayApi = async (productCode) => {
    try {
        const token = getCookie("T6hVzR7c0g3maM3F")
        const iv = getCookie("02hfCmUqpk66w4uG")
        const id = getCookie("3F2Mb2pJ1YRro5Z4")

        const option = {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }

        const res = await axios.get(`${API_URL}/api/V2/stockEnterEssay/getAllEntersByLotNumber/${id}/${iv}?productCode=${productCode}`, option);
        return res.data
    }
    catch (err) {
        throw err
    }
}
